module.exports = __webpack_public_path__ + "static/img/viral_30.54dbf49c.jpeg";